/* Block explorers by EVM chain id, as the whitelabel maps them. A hash is only
   independently verifiable if the player can open it somewhere we do not run,
   so a chain this table does not know gets a copyable hash and no link, never
   a guessed URL. */

const EXPLORERS: Record<number, string> = {
  10: "https://optimistic.etherscan.io",
  50: "https://xdcscan.io",
  51: "https://explorer.apothem.network",
  919: "https://919.testnet.thesuperscan.io",
  1281: "https://moonbeam-explorer.netlify.app",
  1284: "https://moonscan.io",
  8453: "https://basescan.org",
  34443: "https://modescan.io",
  42161: "https://arbiscan.io",
  42793: "https://explorer.etherlink.com",
  81457: "https://blastscan.io",
  84532: "https://sepolia.basescan.org",
  128123: "https://testnet.explorer.etherlink.com",
  127823: "https://shadownet.explorer.etherlink.com",
  421614: "https://sepolia.arbiscan.io",
  11155420: "https://sepolia-optimism.etherscan.io",
  168587773: "https://sepolia.blastscan.io",
};

export const explorerTxUrl = (chainId: number | undefined, hash: string): string | null => {
  if (chainId === undefined) return null;

  const base = EXPLORERS[chainId];

  return base ? `${base}/tx/${hash}` : null;
};

export const explorerAddressUrl = (chainId: number | undefined, address: string): string | null => {
  if (chainId === undefined) return null;

  const base = EXPLORERS[chainId];

  return base ? `${base}/address/${address}` : null;
};
